<template>
  <b-row>
    <b-col>
      <span style="display-inline;">
        Fishbowl Data:
        <b-button size="sm" variant="link" @click="$emit('showModal', 'fishbowl')" class="px-0">
          <i class="fas fa-question-circle"></i>
        </b-button>
      </span>
      <b-row>
        <b-col>
          <table class="table b-table internal-table">
            <thead>
              <tr>
                <th>Available For Sale =</th>
                <th>On Hand</th>
                <th>- Allocated</th>
                <th>- Not Sellable</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{item.fb_available_for_sale}}</td>
                <td>{{item.in_amhq}}</td>
                <td>{{item.allocated}}</td>
                <td>{{item.not_sellable}}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
        <b-col>
          <table class="table b-table internal-table">
            <thead>
              <tr>
                <th>Available To Pick =</th>
                <th>On Hand</th>
                <th>- Committed</th>
                <th>- Not Pickable</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{item.fb_available_for_pick}}</td>
                <td>{{item.in_amhq}}</td>
                <td>{{item.committed}}</td>
                <td>{{item.not_pickable}}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
        <b-col  cols=3>
          <table class="table b-table internal-table">
            <thead>
              <tr>
                <th>On Order</th>
                <th>Short</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{item.qty_on_order_mo + item.qty_on_order_so + item.qty_on_order_po}}</td>
                <td>{{item.short}}</td>               
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    item: { type: Object, default: () => {} },
  },
}
</script>

<style
  scoped>
  *{text-align: center}
</style>



// WEBPACK FOOTER //
// src/components/inventory/FishbowlData.vue